/// <reference types="jquery.validation" />
import $ from "@optionaldeps/jquery"

export default $?.validator;